import React, {Component} from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import InputValidationView from '@adsk/bim360-matrix-react-input-validation-view';
import FormLabel from './FormLabel';
import {childrenType} from '../../constants/proptype-validation';

/**
 * @class
 */
class FormField extends Component {
  /**
   * render
   */
  render() {
    const {
      children,
      className,
      labelText,
      actionButton,
      showFieldError,
      infoPopoverText,
      container,
      isFieldMandatory,
      errorMessageText,
      fieldRef,
      inputValidationViewType
    } = this.props;

    const errorMessage = showFieldError ? errorMessageText : null;
    const containerClass = cx('FormField', className);
    return (
      <div className={containerClass} ref={fieldRef} data-testid={this.props['data-testid']}>
        <div className="FormField__label">
          {labelText && (
            <FormLabel isFieldMandatory={isFieldMandatory} infoPopoverText={infoPopoverText} container={container}>
              {labelText}
            </FormLabel>
          )}
          {actionButton}
        </div>
        <InputValidationView message={errorMessage} type={inputValidationViewType} popoverContainer={container}>
          {children}
        </InputValidationView>
      </div>
    );
  }
}

FormField.displayName = 'FormField';

FormField.propTypes = {
  children: childrenType.isRequired,
  actionButton: PropTypes.node,
  labelText: PropTypes.string,
  infoPopoverText: PropTypes.string,
  container: PropTypes.object,
  showFieldError: PropTypes.bool,
  isFieldMandatory: PropTypes.bool,
  errorMessageText: PropTypes.string,
  fieldRef: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
  className: PropTypes.string,
  inputValidationViewType: PropTypes.oneOf(Object.values(InputValidationView.Types)),
  'data-testid': PropTypes.string
};

export default FormField;
